// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState'
import { reducer as loadItemNuevoReducer } from './loadItemNuevo'
import { reducer as onChangeSumarCantidadReducer } from './onChangeSumarCantidad'
import { reducer as clearItemNuevoReducer } from './clearItemNuevo'
import { reducer as setSpecialBonificationReducer } from './setSpecialBonification/reducer'
import { reducer as clearBonificacionVendedorReducer } from './clearBonificacionVendedor'
import { reducer as clearPresupuestoReducer } from './clearPresupuesto'
import { reducer as validateCostoPatentamientoReducer } from './validateCostoPatentamiento'
import { reducer as getCotizacionReducer } from './getCotizacion'
import { reducer as setBonificationTakingCarReducer } from './setBonificationTakingCar/reducer';
import { reducer as removeEntregaUsadoReducer } from './removeEntregaUsado'
import { reducer as selectStockReducer } from './selectStock'
import { reducer as addUsadoEntregarReducer } from './addUsadoEntregar'
import { reducer as getLineasFinancierasReducer } from './getLineasFinancieras'
import { reducer as setCuotaMontoReducer } from './setCuotaMonto'
import { reducer as selectLineaFinancieraReducer } from './selectLineaFinanciera'
import { reducer as savePresupuestoReducer } from './savePresupuesto'
import { reducer as generateSellRequestReducer } from './generateSellRequest'
import { reducer as updateStatePresupuestoReducer } from './updateStatePresupuesto'
import { reducer as selectTipoVentaReducer } from './selectTipoVenta'
import { reducer as validatePatentAppraisedReducer } from './validatePatentAppraised';
import { reducer as solicitarPeritajeReducer } from './solicitarPeritaje';
import { reducer as listaDePresupuestosReducer } from './listaDePresupuestos';
import { reducer as getGastosDeEntregaCheckedReducer } from './getGastosDeEntregaChecked';
import { reducer as saveClientReducer } from './saveClient';
import { reducer as getPdfReducer } from './getPdf';
import { reducer as getCuotaPromedioAndCftReducer } from './getCuotaPromedioAndCft';
import { reducer as cleanPdfReducer } from './cleanPdf';
import { reducer as postClienteReducer } from './postCliente';
import { reducer as sendEmailReducer } from './sendEmail';
import { reducer as getPresupuestoReducer } from './getPresupuesto';
import { reducer as clienteSirenaReducer } from './clienteSirena';
import { reducer as limpiarErroresResumenReducer } from './limpiarErroresResumen';
import { reducer as actualizarPeritajesReducer } from './actualizarPeritajes';
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as clearLeadPresupuestadorReducer } from './clearLeadPresupuestador';
import { reducer as buscarAutoEntregaReducer } from './buscarAutoEntrega';
import { reducer as agregarPatenteReducer } from './agregarPatente';
import { reducer as setPatenteReducer } from './setPatente';
import { reducer as deleteBudgetReducer } from './deleteBudget';
import { reducer as getListaClienteReducer } from './getListaCliente';
import { reducer as controlClientIdReducer } from './controlClientId';
import { reducer as modalDeReservaReducer } from './modalDeReserva';
import { reducer as saveColorsReducer } from './saveColors';
import { reducer as setTestDriveReducer } from './setTestDrive';
import { reducer as getCostosPatentamientoReducer } from './getCostosPatentamiento';
import { reducer as saveCommentsReducer } from './saveComments';
import { reducer as selectBusinessUnitReducer } from './selectBusinessUnit';
import { reducer as getLineasFinancierasReservadoReducer } from './getLineasFinancierasReservado';
import { reducer as getPresupuestoUltimoEditadoReducer } from './getPresupuestoUltimoEditado';
import { reducer as validateSolicitudPendienteReducer } from './validateSolicitudPendiente';
import { reducer as clearBonificacionUsado } from './clearBonificacionUsado';
import { reducer as getPeritajeReducer } from './getPeritaje/reducer';
import { reducer as searchPantenteReducer } from './searchPatent/reducer';
import { reducer as updateTakingCarReducer } from './updateTakingCar/reducer';
import { reducer as calculateRemainderReducer } from './calculateRemainder/reducer';
import { reducer as getReportPresupuestadorReducer } from './getReportPresupuestador';
import { reducer as clearBonificationTakingCar } from './clearBonificationTakingCar/reducer';
import { reducer as clearReportPresupuestadorReducer } from './clearReportPresupuestador';
import { reducer as setDisableBtnSave } from './setDisableBtnSave/reducer';
import { reducer as updateVehicleDataReducer } from './updateVehicleData';
import { reducer as setIntegrationClient } from './setIntegrationClient/reducer';
import { reducer as setSortFinancialLineReducer } from './setSortFinancialLine';
import { reducer as setFeeReducer } from './setFee';
import { reducer as setPayReducer } from './setPay';
import { reducer as setLinesFinanceReducer } from './setLinesFinance';
import { reducer as saveOwnerBranchReducer } from './saveOwnerBranch';
import { reducer as setErrorAmount } from './setErrorAmount/reducer';
import { reducer as clearPatente } from './clearPatente';
import { reducer as setIsReservation } from './setIsReservation/reducer';
import { reducer as updateMaxCap } from './updateMaxCap';
import { reducer as setLeadId } from './setLeadId';
import { reducer as bonificationReducer } from './bonification'
import { reducer as setBranchOfficeListReducer } from './setBranchOfficeList'
import { reducer as setNewDeliveryCost } from './setNewDeliveryCost'
import { reducer as setPriceIncrease } from './setPriceIncrease'
import { reducer as clearOwnerFields } from './clearOwnerFields'
import { reducer as addPaymentMethod } from './addPaymentMethod'
import { reducer as clearPaymentsMethods } from './clearPaymentsMethods'
import { reducer as deletePaymentMethod } from './deletePaymentMethod'

const reducers = [
  loadItemNuevoReducer,
  onChangeSumarCantidadReducer,
  clearItemNuevoReducer,
  setSpecialBonificationReducer,
  clearBonificacionVendedorReducer,
  clearPresupuestoReducer,
  validateCostoPatentamientoReducer,
  getCotizacionReducer,
  setBonificationTakingCarReducer,
  removeEntregaUsadoReducer,
  selectStockReducer,
  getPeritajeReducer,
  addUsadoEntregarReducer,
  getLineasFinancierasReducer,
  setCuotaMontoReducer,
  selectLineaFinancieraReducer,
  savePresupuestoReducer,
  generateSellRequestReducer,
  updateStatePresupuestoReducer,
  selectTipoVentaReducer,
  validatePatentAppraisedReducer,
  solicitarPeritajeReducer,
  listaDePresupuestosReducer,
  getGastosDeEntregaCheckedReducer,
  saveClientReducer,
  getPdfReducer,
  getCuotaPromedioAndCftReducer,
  cleanPdfReducer,
  postClienteReducer,
  sendEmailReducer,
  getPresupuestoReducer,
  clienteSirenaReducer,
  limpiarErroresResumenReducer,
  actualizarPeritajesReducer,
  clearLeadPresupuestadorReducer,
  buscarAutoEntregaReducer,
  agregarPatenteReducer,
  setPatenteReducer,
  deleteBudgetReducer,
  getListaClienteReducer,
  controlClientIdReducer,
  modalDeReservaReducer,
  saveColorsReducer,
  setTestDriveReducer,
  getCostosPatentamientoReducer,
  saveCommentsReducer,
  selectBusinessUnitReducer,
  getLineasFinancierasReservadoReducer,
  getPresupuestoUltimoEditadoReducer,
  validateSolicitudPendienteReducer,
  clearBonificacionUsado,
  searchPantenteReducer,
  updateTakingCarReducer,
  calculateRemainderReducer,
  getReportPresupuestadorReducer,
  clearBonificationTakingCar,
  clearReportPresupuestadorReducer,
  setDisableBtnSave,
  clearBonificationTakingCar,
  updateVehicleDataReducer,
  setIntegrationClient,
  setSortFinancialLineReducer,
  setFeeReducer,
  setPayReducer,
  setLinesFinanceReducer,
  saveOwnerBranchReducer,
  setErrorAmount,
  clearPatente,
  setIsReservation,
  updateMaxCap,
  setLeadId,
  bonificationReducer,
  setBranchOfficeListReducer,
  setNewDeliveryCost,
  setPriceIncrease,
  clearOwnerFields,
  addPaymentMethod,
  clearPaymentsMethods,
  deletePaymentMethod,
]

export default function reducer(state = initialState, action) {
  let newState
  switch (action.type) {
    // Handle cross-topic actions here
    case LOGOUT_USER:
      newState = initialState;
      break;
    default:
      newState = state
      break
  }
  return reducers.reduce((s, r) => r(s, action), newState)
}
